exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#loading-error {\n  padding: 20px; }\n  #loading-error .btn {\n    margin-top: 20px; }\n  #loading-error .login-btn {\n    margin-right: 0px; }\n  #loading-error #create-account-btn {\n    margin-left: 10px; }\n  #loading-error #not-found-img {\n    max-width: 20%;\n    margin: 20px 0; }\n  #loading-error #links-row {\n    margin-top: 50px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/core/loading-error.sass
// module id = 794
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91